module.exports = {
  production: false,
  protocol: "https",
  host: "0.0.0.0",
  port: "4000",
  api: "https://x525qvqh46.execute-api.eu-west-1.amazonaws.com/development",
  authUrl: "https://uunn-backoffice-development.auth.eu-west-1.amazoncognito.com/login?response_type=token&client_id=2ma1u1g7nf9mp978lf9090oust&redirect_uri=https://df980pzpfz49x.cloudfront.net/login",
  logoutUrl: "https://uunn-backoffice-development.auth.eu-west-1.amazoncognito.com/logout?client_id=2ma1u1g7nf9mp978lf9090oust&logout_uri=https://df980pzpfz49x.cloudfront.net/login"
};
